module.exports = __webpack_public_path__ + "img/DSImage2.2ad48cc9.png";